import React from 'react';
import styled from 'styled-components';

import type { CollectionEntity } from 'collections/types';
import { createGRN } from 'logic/permissions/GRN';
import useShowRouteFromGRN from 'routing/hooks/useShowRouteFromGRN';
import useHasEntityPermissionByGRN from 'hooks/useHasEntityPermissionByGRN';
import { Link } from 'components/common/router';
import { RestrictedAccessTooltip } from 'components/common';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

type Props = Pick<CollectionEntity, 'id' | 'name' | 'type'>;

const TitleCell = ({ id, name, type }: Props) => {
  const grn = createGRN(type, id);
  const hasReadPermission = useHasEntityPermissionByGRN(grn, 'read');

  const entityRoute = useShowRouteFromGRN(grn);

  if (hasReadPermission) {
    return <Link to={entityRoute}>{name}</Link>;
  }

  return (
    <Wrapper>
      {name} <RestrictedAccessTooltip entityName={type} capabilityName="view" />
    </Wrapper>
  );
};
export default TitleCell;
